import React from 'react';
import { DermaclinicLanding } from './pages/DermaclinicLanding';
export function App() {
  return <DermaclinicLanding data-id="element-0" />;
}